import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import * as models from '../../../models';

export const USER_SERVICE_TOKEN = new InjectionToken('Core.IUserService');

export interface IUserService {
  getUser(request: GetUserRequest): Observable<GetUserResponse>;
  signOut(request: SignOutRequest): Observable<SignOutResponse>;
  logUserActivity(request: models.UserActionsEnum): Observable<LogUserActivityResponse>;
}

export class GetUserRequest {
}

export class GetUserResponse {
  entity: models.User;
}

export class SignOutRequest {
}

export class SignOutResponse {
}

export class LogUserActivityResponse {}
